/* eslint-disable camelcase */
import { match, Default as _ } from '@nike/rcf-fp';
import PropTypes from 'prop-types';
import React from 'react';
import { useSelector } from 'react-redux';

import {
  JORDAN, NIKE, WEBSITE_URL_JORDAN, WEBSITE_URL_NIKE, WORLD_OF_FLIGHT
} from '../../../utils/constants';

import SwedenAdditionalHeader from './SwedenAdditionalHeader';
import './style.css';

const getEnLocalization = (localizations) => localizations?.find((loc) => loc.language === 'en')?.address;
const companyRegistrationNumber = 'T9010701007169';

const getUpdatedAddress = (country, digitalOrder, localizations, isJordan) => {
  if (digitalOrder && country === 'KOR') {
    return {
      address1: '테헤란로 152, 30층',
      city: '강남구',
      name: '유한회사 나이키코리아',
      phoneNumber: '+080-022-0182',
      postalCode: '06236',
      state: '서울특별시'
    };
  } else if (country === 'JPN') {
    return {
      address1: '********* ********* *********',
      url: isJordan ? WEBSITE_URL_JORDAN : WEBSITE_URL_NIKE,
    };
  } else if (['TWN', 'HKG', 'MAC'].includes(country)) {
    const enLocalization = getEnLocalization(localizations);
    if (enLocalization) {
        const {
          address1, address2, address3, city, storeName: name, state, postalCode
        } = enLocalization;
        return {
          address1,
          address2,
          address3,
          city,
          name,
          postalCode,
          state
        };
    }
  }
  return null;
};
const StoreHeader = ({
  address, name, phoneNumber, digitalOrder, locale, localizations, transaction, taxes, storeConcept
}) => {
  const { RF_Telephone, RL_CompanyRegistrationNumber } = useSelector((state) => state);
  const locationCode = transaction.BusinessUnit?.LocationCode || '';
  const rfcNumber = (tax) => (tax?.find((t) => t?.Tax).Tax?.VATIdentifiers?.find((vat) => vat?.Type === 'RFCNumber')?.Value);
  const isJordan = storeConcept === JORDAN || storeConcept === WORLD_OF_FLIGHT;

  const addBranchIssueNumber = (code) => match(code)(
    ['6811', '11'],
    ['6812', '7'],
    ['6813', '9'],
    ['6814', '00008'],
    ['6815', '10'],
    [_, '']
  );
  const updatedAddress = getUpdatedAddress(address.country, digitalOrder, localizations, isJordan) || address;
  const IndiaStoreHeader = (<p>Nike India Private Limited</p>);

  return (
    <>
      <i className={`${isJordan ? 'g72-jordan' : 'g72-swoosh'} text-color-primary-dark nike-swoosh-logo`} />
      <p>{isJordan ? JORDAN : NIKE}</p>
      {/* May need to add Partner Display Name here in the future. */}
      {locale.localeName === 'en-IN' && IndiaStoreHeader}
      <p>{ updatedAddress.name || name}</p>
      <p>{`${updatedAddress.url || ''}`}</p>
      <p>{updatedAddress.address1}{updatedAddress.address2 ? ` ${updatedAddress.address2}` : ''}</p>
      <p>{updatedAddress.address3 ? ` ${updatedAddress.address3}` : ''}</p>
      <p>{`${updatedAddress.city ? `${updatedAddress.city},` : ''} ${updatedAddress.state ?? (updatedAddress.area ?? '')} ${updatedAddress.postalCode || ''}`}</p>
      <p>{transaction.NikeDigital?.Country === 'MEX' && rfcNumber ? `RFC: ${rfcNumber(taxes)}` : ''}</p>
      <p>{RF_Telephone}: {updatedAddress.phoneNumber || phoneNumber}</p>
      <div>{locale.localeName === 'ja-JP' && <p>{RL_CompanyRegistrationNumber} : {companyRegistrationNumber}</p>}</div>
      <p>{updatedAddress.country === 'THA' && `Branch Issue No.: ${addBranchIssueNumber(locationCode)}`}</p>
      {locale.localeName === 'sv-SE' && (<SwedenAdditionalHeader companyRegistrationNumber={transaction?.BusinessUnit?.CompanyRegistrationNumber} invoiceNumber={transaction?.InvoiceNumber} retailTransaction={transaction?.RetailTransaction}> </SwedenAdditionalHeader>)}
      <br />
    </>
  );
};

StoreHeader.defaultProps = {
  address: {},
  digitalOrder: undefined,
  locale: {},
  localizations: [],
  name: '',
  phoneNumber: '',
  storeConcept: null,
  taxes: []
};

StoreHeader.propTypes = {
  address: PropTypes.shape(),
  digitalOrder: PropTypes.number,
  locale: PropTypes.shape(),
  localizations: PropTypes.arrayOf(PropTypes.shape()),
  name: PropTypes.string,
  phoneNumber: PropTypes.string,
  storeConcept: PropTypes.string,
  taxes: PropTypes.arrayOf(PropTypes.shape()),
  transaction: PropTypes.shape().isRequired
};

export default StoreHeader;
